export const formatDate = (dateStr = new Date()) => {
  const date = new Date(dateStr);
  const formatter = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/New_York", 
    year: "numeric",
    month: "long",
    day: "numeric",
  });
  return formatter.format(date);
};




  export const formatDateDetailed = (dateInput = new Date(), {
  includeTime = false,
  timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone,
  locale = 'en-US',
} = {}) => {
  const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;
  if (isNaN(date)) return '';

  const options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone,
    ...(includeTime && {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false, // change to true for AM/PM
    }),
  };

  return new Intl.DateTimeFormat(locale, options).format(date);
};


